import React, { FC, ReactNode } from 'react';
import { User } from '../../types';
import CurrentUserContext from './CurrentUserContext';

type Props = {
  children: ReactNode;
  hasUnreadMessages?: boolean;
  hasUnreadNotifications?: boolean;
  user?: User;
};

const CurrentUserProvider: FC<Props> = ({
  children,
  hasUnreadMessages = false,
  hasUnreadNotifications = false,
  user
}): JSX.Element => (
  <CurrentUserContext.Provider
    value={{
      currentUser: user,
      hasUnreadMessages,
      hasUnreadNotifications,
      isLoggedIn: Boolean(user)
    }}
  >
    {children}
  </CurrentUserContext.Provider>
);

export default CurrentUserProvider;
